import React, { useState, useEffect } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import './filter-popup.scss';
import Calendar from '../../../../common/Calendar'
import { useTranslation } from 'react-i18next'
import { Slider } from 'primereact/slider';
import { InputText } from 'primereact/inputtext';
import filterIcon from '../../../../assets/images/filter.svg';
import filterActiveIcon from '../../../../assets/images/filter-active.svg';
import moment from 'moment';
import { padLeadingZeros } from '../../../../utils/Validations'
import { validateNumericIfPresent, validateRequired } from '../../../CaptureAWB/captureAwbUtils'
import {
    validateFlightNoRegex,
    allowAlphaOnly,
    validateCarrierCodeRequired,
    removeError,
    restrictSpaceSpecial,
    hasError,
    allowNumricOnly,
    formatInputTypeNumber,
    validateAWB,
} from '../../../ManageBooking/ListBooking/ListbookingValidations'
import { Dropdown } from '../../../../common/DropDown'
import { MultiSelect } from 'primereact/multiselect';
import getPrincipal from '../../../../utils/getPrincipal'
import closeIcon from "../../../../assets/images/close.png";
// import closeIcon from "../../assets/images/close.png";
import AppCalendar from '../../../../common/Calendar'
import { CommonDropDown } from '../../../../common/Resusable/CommonDropDown'
import CommonInput from "../../../../common/Resusable/CommonInput";
import up from "../../../../assets/images/chevron-up.png";
import down from "../../../../assets/images/chevronDown.svg";

const FilterPopup = ({
    op,
    setFilterSummary,
    handleFilterAction,
    maxDate,
    flightFromDate,
    flightToDate,
    formatDate,
    setCalculatedPageNumber,
    setPageIndex,
    flightSummaryApplyFilter,
    flightSummaryFilter,
    setFlightsRefreshed,
    flightsRefreshed,
    setFiltered,
    setFlightFilter,
    flightFilter,
    setFilterValues,
    filterValues,
    airportsMasterData,
    placiUser
}) => {
    const { t, i18n } = useTranslation(['labels', 'errors'])
    const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
    const [carrierCode, setCarrierCode] = useState('EY')
    const [flightNo, setFlightNo] = useState('')
    const [departureFromDate, setDepartureFromDate] = useState('')
    const [departureToDate, setDepartureToDate] = useState('')
    const [arrivalFromDate, setArrivalFromDate] = useState('')
    const [arrivalToDate, setArrivalToDate] = useState('')
    const [toDate, setToDate] = useState('')
    //const [showFilterModal, setShowFilterModal] = useState(false);
    const [departureTime, setDepartureTime] = useState([0, 1439]);
    const [departureTimeInHours, setDepartureTimeInHours] = useState([
        '0:00 AM',
        '23:59 PM',
    ])
    const [arrivalTime, setArrivalTime] = useState([0, 1439])
    const [arrivalTimeInHours, setArrivalTimeInHours] = useState([
        '0:00 AM',
        '23:59 PM',
    ])
    const [finalized, setFinalized] = useState(false)
    const [onHold, setOnHold] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [error, setError] = useState(null);
    const [utc, setUtc] = useState(false);
    const [departedFlights, setDepartedFlights] = useState(false);
    // const [timeText, setTimeText] = useState(' ');
    const [timeText, setTimeText] = useState('');

    const [timeError, setTimeError] = useState(false);
    const [depDateError, setDepDateError] = useState(false);
    const [arrDateError, setArrDateError] = useState(false);
    const [depFromerrorMessage, setDepFromErrorMessage] = useState(false);
    const [depToerrorMessage, setDepToErrorMessage] = useState(false);
    const [arrivalFromerrorMessage, setArrivalFromErrorMessage] = useState(false);
    const [arrivalToerrorMessage, setArrivalToErrorMessage] = useState(false);
    const [awbPrefix, setAwbPrefix] = useState('607')
    const [awbNumber, setAwbNumber] = useState('')
    const [filterByAwbNumber, setFilterByAwbNumber] = useState(false)
    const [stdOptions, setStdOptions] = useState([])
    const [isFlightCancelled, setIsFlightCancelled] = useState(false);
    const [isNoBookingChecked, setIsNoBookingChecked] = useState(false);

    const [selectedAirports, setSelectedAirports] = useState(null)
    const [selectedCountries, setSelectedCountries] = useState(null);
    const [selectedRegions, setSelectedRegions] = useState(null);

    let principal = getPrincipal()

    const [polType, setPolType] = useState('AIR')

    const [stationCodes, setStationCodes] = useState([])

    const polTypes = [
        { label: "Airport", value: "AIR" },
        ...(principal?.type === 'enterprise' ? [{ label: "Country", value: "COU" },
        { label: "Region", value: "REG" }] : [])
    ]

    const airports = principal?.type === 'enterprise' ? airportsMasterData ? airportsMasterData.airports : null : stationCodes;

    const countries = airportsMasterData ? airportsMasterData.countries : null

    const regions = airportsMasterData ? airportsMasterData.regions : null

    const remainingTimeList = [
        { label: ' 01:00', value: '01:00' },
        { label: ' 02:00', value: '02:00' },
        { label: ' 03:00', value: '03:00' },
        { label: ' 04:00', value: '04:00' },
        { label: ' 05:00', value: '05:00' },
        { label: ' 06:00', value: '06:00' },
        { label: ' 07:00', value: '07:00' },
        { label: ' 08:00', value: '08:00' },
        { label: ' 09:00', value: '09:00' },
        { label: ' 10:00', value: '10:00' },
        { label: ' 11:00', value: '11:00' },
        { label: ' 12:00', value: '12:00' },
    ]
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (placiUser && placiUser.stationCode) {
            const stations = placiUser.stationCode.split(',')?.map(item => ({ airportCode: item.trim() }));
            setStationCodes(stations);
        }

    }, [placiUser])

    useEffect(() => {
        if (flightsRefreshed) {
            //resetFilter()
            setFlightsRefreshed(false)
        }
    }, [flightsRefreshed])

    useEffect(() => {
        // if(!flightSummaryFilter?.depDetails?.utcInterval){
        if (utc && !departedFlights) {
            setTimeText('03:00')
            setStdOptions(remainingTimeList)
        }
        else {
            setTimeText('')
            //setStdOptions([{ label: ' HH:mm', value: '' }])
            setStdOptions([])
        }
        // }
    }, [utc, flightSummaryFilter])

    const getFilterData = () => {
        let statusArray = [];
        if (finalized) {
            statusArray.push('FINALISED')
        }
        if (onHold) {
            statusArray.push('ONHOLD')
        }
        if (inProgress) {
            statusArray.push('IN_PROGRESS')
        }
        if (isFlightCancelled) {
            statusArray.push('CANCELLED')
        }
        if (isNoBookingChecked) {
            statusArray.push('NO_BOOKINGS')
        }
        return {
            "depDetails": {
                "fromDate": departureFromDate,
                "toDate": departureToDate,
                "fromTime": departureTimeInHours[0],
                "toTime": departureTimeInHours[1],
                "utc": utc,
                "utcInterval": timeText,
                showDepartedFlights: departedFlights,
            },
            "arrDetails": {
                "fromDate": arrivalFromDate,
                "toDate": arrivalToDate,
                "fromTime": arrivalTimeInHours[0],
                "toTime": arrivalTimeInHours[1]
            },
            "status": statusArray,
            carrierCode: flightNo && flightNo !== '' && carrierCode && carrierCode !== '' ? carrierCode : null,
            flightNumber: flightNo && flightNo !== '' ? flightNo : null,
            airlinePrefix: awbPrefix && awbPrefix !== '' && awbNumber && awbNumber !== '' ? awbPrefix : null,
            awbNumber: awbNumber && awbNumber !== '' ? awbNumber : null,
            stations: selectedAirports ? selectedAirports : null,
            selectedCountries: selectedCountries ? selectedCountries : null,
            selectedRegions: selectedRegions ? selectedRegions : null
        }
    }

    useEffect(() => {
        if (flightSummaryFilter) {
            if (flightSummaryFilter?.depDetails?.fromDate !== "") {
                setDepartureFromDate(flightSummaryFilter.depDetails.fromDate)

            }

            if (flightSummaryFilter?.depDetails?.toDate !== "") {
                setDepartureToDate(flightSummaryFilter.depDetails.toDate)

            }
            if (flightSummaryFilter?.arrDetails?.fromDate !== "") {
                setArrivalFromDate(flightSummaryFilter.arrDetails.fromDate)
            }
            if (flightSummaryFilter?.arrDetails?.toDate !== "") {
                setArrivalToDate(flightSummaryFilter.arrDetails.toDate)
            }
            setDepartureTimeInHours([
                flightSummaryFilter?.depDetails.fromTime, flightSummaryFilter.depDetails.toTime
            ])
            setArrivalTimeInHours([
                flightSummaryFilter.arrDetails.fromTime, flightSummaryFilter.arrDetails.toTime
            ])
            if (flightSummaryFilter?.status) {
                if (flightSummaryFilter.status.includes('FINALISED')) {
                    setFinalized(true)
                }
                if (flightSummaryFilter.status.includes('ONHOLD')) {
                    setOnHold(true)
                }
                if (flightSummaryFilter.status.includes('IN_PROGESS')) {
                    setInProgress(true)
                }
                if (flightSummaryFilter.status.includes('CANCELLED')) {
                    setIsFlightCancelled(true)
                }
                if (flightSummaryFilter.status.includes('NO_BOOKINGS')) {
                    setIsNoBookingChecked(true)
                }
            }
            setUtc(flightSummaryFilter.depDetails.utc)
            setDepartedFlights(flightSummaryFilter.depDetails.showDepartedFlights)
            setTimeText(flightSummaryFilter.depDetails.utcInterval)
            setFlightNo(flightSummaryFilter.flightNumber ? flightSummaryFilter.flightNumber : '')
            setCarrierCode(flightSummaryFilter.carrierCode ? flightSummaryFilter.carrierCode : 'EY')
            setAwbPrefix(flightSummaryFilter.airlinePrefix ? flightSummaryFilter.airlinePrefix : '607')
            setAwbNumber(flightSummaryFilter.awbNumber ? flightSummaryFilter.awbNumber : '')
            setFilterByAwbNumber(flightSummaryFilter.awbNumber ? true : false)
            if (flightSummaryFilter?.stations) {
                setSelectedAirports(flightSummaryFilter?.stations)
                if (flightSummaryFilter.selectedRegions && flightSummaryFilter.selectedRegions.length > 0) {
                    setPolType('REG')
                    setSelectedRegions(flightSummaryFilter.selectedRegions)
                } else if (flightSummaryFilter.selectedCountries && flightSummaryFilter.selectedCountries.length > 0) {
                    setPolType('COU')
                    setSelectedCountries(flightSummaryFilter.selectedCountries)
                } else {
                    setPolType('AIR')
                }
            }
        }
    }, [flightSummaryFilter])

    const showFilter = (e) => {
        op.current.toggle(e)

        if (filterValues) {
            if (filterValues.depDetails) {
                setDepartureFromDate(filterValues.depDetails.fromDate)
                setDepartureToDate(filterValues.depDetails.toDate)
                setDepartureTimeInHours(filterValues.depDetails.departureTimeInHours)
                setDepartureTime(filterValues.depDetails.departureTime)
                setUtc(filterValues.depDetails.utc)
                setTimeText(filterValues.depDetails.showDepartedFlights ? '' : filterValues.depDetails.utcInterval)
                setDepartedFlights(filterValues.depDetails.showDepartedFlights)
            }
            if (filterValues.arrDetails) {
                setArrivalFromDate(filterValues.arrDetails.fromDate)
                setArrivalToDate(filterValues.arrDetails.toDate)
                setArrivalTimeInHours(filterValues.arrDetails.arrivalTimeInHours)
                setArrivalTime(filterValues.arrDetails.arrivalTime)
            }
            if (filterValues.customsStatus) {
                setFinalized(filterValues.customsStatus.finalized)
                setOnHold(filterValues.customsStatus.onHold)
                setInProgress(filterValues.customsStatus.inProgress)
                setIsFlightCancelled(filterValues.customsStatus.isFlightCancelled)
                setIsNoBookingChecked(filterValues.customsStatus.isNoBookingChecked)
            }
            setFlightNo(filterValues.flightNumber ? filterValues.flightNumber : '')
            setCarrierCode(filterValues.carrierCode ? filterValues.carrierCode : 'EY')
            if (filterValues.airlinePrefix && filterValues.awbNumber) {
                setFilterByAwbNumber(true)
                setAwbPrefix(filterValues.airlinePrefix)
                setAwbNumber(filterValues.awbNumber)
            } else {
                setFilterByAwbNumber(false)
            }
            if (filterValues?.stations) {
                setSelectedAirports(filterValues?.stations)
                if (filterValues.selectedRegions && filterValues.selectedRegions.length > 0) {
                    setPolType('REG')
                    setSelectedRegions(filterValues.selectedRegions)
                } else if (filterValues.selectedCountries && filterValues.selectedCountries.length > 0) {
                    setPolType('COU')
                    setSelectedCountries(filterValues.selectedCountries)
                } else {
                    setPolType('AIR')
                }
            } else {
                setPolType('AIR')
                setSelectedAirports(null)
                setSelectedCountries(null)
                setSelectedRegions(null)
            }
        }
    }

    const covertDecimalToTime = (component, value) => {
        let startTime, endTime

        value.forEach((element, index) => {
            let hoursAndMinute = element / 60
            let hour = parseInt(hoursAndMinute)
            let minute = hoursAndMinute % 1
            minute = parseInt(minute * 60)
                .toString()
                .padStart(2, 0)
            if (index === 0) {
                startTime =
                    hour >= 12 ? hour + ':' + minute + ' PM' : hour + ':' + minute + ' AM'
            } else {
                endTime =
                    hour >= 12 ? hour + ':' + minute + ' PM' : hour + ':' + minute + ' AM'
            }
        })
        if (component === 'departure') {
            setDepartureTimeInHours([startTime, endTime])
            setDepartureTime(value)
        } else if (component === 'arrival') {
            setArrivalTimeInHours([startTime, endTime])
            setArrivalTime(value)
        }
    }

    const handleRadioUtc = () => {
        setUtc(!utc)
        setDepartedFlights(false)
        setDepDateError(null)
        setDepartureFromDate('')
        setDepartureToDate('')
        setDepartureTime([0, 1439]);
        setDepartureTimeInHours([
            '0:00 AM',
            '23:59 PM',
        ]);
        setCarrierCode('EY')
        setFlightNo('')
        setAwbPrefix('607')
        setAwbNumber('')
        setError(null)
        setFilterByAwbNumber(false)
        setArrivalFromDate('');
        setArrivalToDate('');
        setArrivalTime([0, 1439]);
        setArrivalTimeInHours([
            '0:00 AM',
            '23:59 PM',
        ]);
        setArrDateError(false)
    }

    const handleRadioFinalized = (e) => {
        setFinalized(!finalized)
    }
    const handleRadioOnHold = (e) => {
        setOnHold(!onHold)
    }

    const handleCheckboxInProgress = (e) => {
        setInProgress(!inProgress)
    }

    const handleCheckBoxCancelled = () => setIsFlightCancelled(prev => !prev)

    const handleCheckBoxNoBookings = () => setIsNoBookingChecked(prev => !prev)

    const onFilter = (e) => {
        setFiltered(true)
        const filterData = getFilterData()
        handleFilterAction(getFilterData());

        filterData.customsStatus = {
            finalized,
            onHold,
            inProgress,
            isFlightCancelled,
            isNoBookingChecked,
        }
        filterData.depDetails.departureTimeInHours = departureTimeInHours
        filterData.depDetails.departureTime = departureTime
        filterData.arrDetails.arrivalTimeInHours = arrivalTimeInHours
        filterData.arrDetails.arrivalTime = arrivalTime
        // Set filter values to state to be used to retain the filter selection
        setFilterValues(filterData)

        // Reset filter data if not filter selected
        if (departureFromDate === '' && arrivalFromDate === '' && !utc && !departedFlights && !finalized && !onHold && !inProgress && !isFlightCancelled && !isNoBookingChecked && (!flightNo || flightNo === '') && (!awbNumber || awbNumber === '') && (!selectedAirports || selectedAirports.length < 1)) {
            setFlightFilter(null)
        }

        if ((departureFromDate !== '') && (departureToDate !== '') && (arrivalFromDate !== '') && (arrivalToDate !== '')) {
            //    added

            setDepFromErrorMessage(false);
            setDepToErrorMessage(false);
            setArrivalFromErrorMessage(false);
            setArrivalToErrorMessage(false);


        }
        else {


            setDepFromErrorMessage(true);
            setDepToErrorMessage(true);
            setArrivalFromErrorMessage(true);
            setArrivalToErrorMessage(true);
            //setDateError(true);

        }


    }

    const clearError = (key) => {
        const tempError = error ? { ...error } : null
        if (tempError) {
            tempError[key] = null
            setError(tempError)
        }
    }

    const getMinDate = () => {
        if (flightFromDate) {
            let minDateCalculated = moment(flightFromDate)
            return minDateCalculated._d;
        }
    }

    const getMaxDate = () => {
        if (flightToDate) {
            let maxDateCalculated = moment(flightToDate);
            return maxDateCalculated._d;
        }
    }

    const handleDepartureFromDate = (date) => {
        date ? setDepartureFromDate(moment(date).format('DD-MMM-YYYY'))
            : setDepartureFromDate('')

        if (date && departureToDate === '') {
            setDepDateError(true)
        } else {
            setDepDateError(false)
        }
    }

    const handleDepartureToDate = (date) => {
        date ? setDepartureToDate(moment(date).format('DD-MMM-YYYY'))
            : setDepartureToDate('')
        if (date && departureFromDate === '') {
            setDepDateError(true)
        } else {
            setDepDateError(false)
        }

    }

    const handleArrivalFromDate = (date) => {
        date ? setArrivalFromDate(moment(date).format('DD-MMM-YYYY'))
            : setArrivalFromDate('')
        if (date && arrivalToDate === '') {
            setArrDateError(true)
        } else {
            setArrDateError(false)
        }
    }

    const handleArrivalToDate = (date) => {
        date ? setArrivalToDate(moment(date).format('DD-MMM-YYYY'))
            : setArrivalToDate('')
        if (date && arrivalFromDate === '') {
            setArrDateError(true)
        } else {
            setArrDateError(false)
        }

    }

    const resetFilter = (awbFilterChecked) => {
        flightSummaryApplyFilter(null)
        setFilterSummary({});
        setDepartureFromDate('');
        setDepartureToDate('');
        setArrivalFromDate('');
        setArrivalToDate('');
        setDepartureTime([0, 1439]);
        setDepartureTimeInHours([
            '0:00 AM',
            '23:59 PM',
        ]);
        setArrivalTime([0, 1439]);
        setArrivalTimeInHours([
            '0:00 AM',
            '23:59 PM',
        ]);
        setFinalized(false);
        setOnHold(false);
        setInProgress(false);
        setUtc(false);
        setTimeText('');
        setStdOptions([])
        setTimeError(false)
        setDepDateError(false)
        setArrDateError(false)
        setFiltered(false)
        //setFlightFilter(null)
        setCarrierCode('EY')
        setFlightNo('')
        setAwbPrefix('607')
        setAwbNumber('')
        setError(null)
        if (!awbFilterChecked) {
            setFilterByAwbNumber(false)
        }
        setDepartedFlights(false)
        setSelectedAirports(null)
        setSelectedCountries(null)
        setSelectedRegions(null)
        setPolType('AIR')
        setIsFlightCancelled(false)
        setIsNoBookingChecked(false)
    }

    const regex = new RegExp('^([0-9][0-9][0-9]*):[0-5][0-9]$');

    const handleText = (e) => {

        setTimeText(e.target.value);
        if ((e.target.value.charAt(0) === '+') || (e.target.value.charAt(0) === '-')) {
            //setTimeError(false);
            let timeEntered = e.target.value.substring(1)
            if (regex.test(timeEntered) === false) {
                setTimeError("Please enter valid time format")
            }
            else {
                setTimeError(false);
            }
        }
        else if (e.target.value === '') {
            setTimeError("Please enter valid time format")
        }
        else {
            if (regex.test(e.target.value) === false) {
                setTimeError("Please enter valid time format")
            }
            else {
                setTimeError(false);
            }
        }
    }

    const handlePolType = (e) => {
        setPolType(e.target.value)
        setSelectedCountries(null)
        setSelectedRegions(null)
        setSelectedAirports(null)
    }

    const handleCountriesFilter = (val) => {
        setSelectedCountries(val)
        let airportsFiltered = airports.filter(airport => val.includes(airport.countryCode))
        const airportsArr = airportsFiltered.map(airport => airport.airportCode)
        setSelectedAirports(airportsArr)
    }

    const handleRegionsFilter = (val) => {
        setSelectedRegions(val)
        let airportsFiltered = airports.filter(airport => val.includes(airport.regionCode))
        const airportsArr = airportsFiltered.map(airport => airport.airportCode)
        setSelectedAirports(airportsArr)
    }

    const validateFlightNo = (flightNo) => {
        let newFlightNumber = flightNo
        if (flightNo) {
            if (flightNo.length < 4) {
                newFlightNumber = padLeadingZeros(flightNo, 4)
                setFlightNo(newFlightNumber)
            }
            if (flightNo.length > 0) {
                const lastDigit = newFlightNumber.charAt(newFlightNumber.length - 1)
                if (isNaN(lastDigit)) {
                    newFlightNumber = padLeadingZeros(flightNo, 5)
                }
                newFlightNumber = newFlightNumber.toUpperCase()
                setFlightNo(newFlightNumber)
            }

            return validateFlightNoRegex(
                newFlightNumber,
                carrierCode,
                setError
            )
        } else {
            return true
        }
    }

    const handleChangeOfFlightNo = (flightNumber) => {
        if (!flightNumber) {
            setFlightNo('')
        }
        if (flightNumber && flightNumber.length <= 5) {
            setFlightNo(flightNumber)
        }
    }

    // const handleChangeOfAWB = (value) => {
    //     if (value.length <= 8) {
    //         setAwbNumber(value)
    //     }
    // }
    // Handle AWB number change
    const handleChangeOfAWB = (value) => {
        if (value.length <= 8) {
            setAwbNumber(value);
            if (error?.awbNumber) {
                setError(prev => ({ ...prev, awbNumber: undefined }));
            }
            if (value !== '' && error?.awbPrefix) {
                setError(prev => ({ ...prev, awbPrefix: undefined }));
            }
        }
    };

    // // Optional: handle focus to clear error (already in your code)
    // const handleFocusAWB = () => {
    //     if (error?.awbNumber) {
    //         setError(prev => ({ ...prev, awbNumber: undefined }));
    //     }
    // };


    return (
        <li className='csn_filter__item'>
            <div className={`showFilter csn-filter filter-link ${flightFilter ? 'active' : ''}`} onClick={(e) => showFilter(e)}>
                <label className="filter-label">{t("COMMON.FILTERS")}</label>
                <img src={visible ? up : down} className="chev-icon" alt="chev-icon" />
            </div>
            <div className='b-none d-lg-block'>
                <OverlayPanel
                    ref={op}
                    className='custom_overlay_panel-flight-summary'
                    appendTo={document.body}
                >
                    <div className="overlay-header">
                        <img src={closeIcon} alt="close" onClick={(e) => {
                            op.current.hide(e)
                            //resetFilter()
                        }} className='close-img'></img>

                    </div>
                    <div className={`flight-search-filter ${isRTL ? 'rtl' : ''}`}>
                        <div className='filter-header-part'>
                            <div className='filter-header-left input-row'>
                                <div className={`form-group awb-input-section mt-4 pt-3 ${(filterByAwbNumber || utc) ? 'disable-time-selection' : ''}`}>
                                    <CommonInput
                                        type="text"
                                        label={t("COMMON.CODE")}
                                        value={carrierCode}
                                        maxLength="2"
                                        onKeyPress={(envt) => {
                                            return allowAlphaOnly(envt)
                                        }}
                                        onChange={(e) => {
                                            setCarrierCode(e.target.value)
                                        }}
                                        onFocus={(e) => {
                                            removeError(e, setError)
                                        }}
                                        onBlur={(e) => {
                                            validateCarrierCodeRequired(
                                                flightNo,
                                                e.target.value,
                                                setError,
                                                'carrierCode'
                                            )
                                        }}
                                        error={
                                            error && error["carrierCode"]
                                                ? t(error["carrierCode"], { ns: "errors" })
                                                : ""
                                        }
                                        wrapperClassName={`awb-prefix`}
                                    />

                                    <CommonInput
                                        type="text"
                                        label={t('COMMON.FLT_NO')}
                                        value={flightNo}
                                        maxLength="5"

                                        onKeyPress={(e) => {
                                            return restrictSpaceSpecial(e)
                                        }}
                                        onFocus={(e) => {
                                            removeError(e, setError)
                                        }}
                                        onChange={(e) => handleChangeOfFlightNo(e.target.value)}
                                        onBlur={(e) => {
                                            validateFlightNo(e.target.value)
                                        }}
                                        error={
                                            error && error["flightNumber"]
                                                ? t(error["flightNumber"], { ns: "errors" })
                                                : ""
                                        }
                                        wrapperClassName={"awb-suffix"}
                                    // isOnlyErrorBorder
                                    />
                                </div>
                                <div className='awb-checkbox-container'>
                                    <div className="l-checkbox">
                                        <input
                                            id='filterByAwb'
                                            checked={filterByAwbNumber}
                                            value={filterByAwbNumber}
                                            type='checkbox'
                                            name='filterByAwb'

                                            onChange={(e) => {
                                                setFilterByAwbNumber(!filterByAwbNumber)
                                                resetFilter(true)
                                            }}

                                        />
                                        <label htmlFor='filterByAwb' className={`mb-0 ${(utc || departedFlights) ? 'disable-time-selection' : ''}`} >
                                            Search by {t('COMMON.AWB_NUMBER')}
                                        </label>
                                    </div>
                                    <div className={`form-group awb-input-section ${(!filterByAwbNumber || utc || departedFlights) ? 'disable-time-selection' : ''}`}>
                                        <CommonInput
                                            type="text"
                                            label={t("COMMON.PREFIX")}
                                            aria-invalid={hasError('awbPrefix', error)}
                                            value={awbPrefix}
                                            maxLength='3'
                                            onKeyPress={(evt) => {
                                                return allowNumricOnly(evt)
                                            }}
                                            onChange={(e) => {
                                                setAwbPrefix(e.target.value)
                                            }}
                                            onFocus={(e) => {
                                                removeError(e, setError)
                                            }}
                                            onBlur={(e) => {
                                                //validateRequired(e.target.value, setError, 'awbPrefix')
                                            }}
                                            error={
                                                error && error["awbPrefix"]
                                                    ? t(error["awbPrefix"], { ns: "errors" })
                                                    : ""
                                            }
                                            wrapperClassName={`awb-prefix`}
                                        />

                                        {/* <CommonInput
                                                type="text"
                                                label={t('COMMON.AWB_NUMBER')}
                                            aria-invalid={hasError('awbNumber', error)}
                                                    // placeholder='AWB'
                                                    value={awbNumber}
                                                    onKeyPress={(evt) => {
                                                        return allowNumricOnly(evt)
                                                    }}
                                                    onKeyDown={(evt) => formatInputTypeNumber(evt)}
                                                    onChange={(e) => handleChangeOfAWB(e.target.value)}
                                                    onBlur={(e) => {
                                                        let isValid = validateAWB(e.target.value, setError, 'awbNumber')
                                                        if (isValid) {
                                                            isValid = validateNumericIfPresent(e.target.value, setError, 'awbNumber')
                                                        }
                                                        if (e.target.value !== '') {
                                                            validateRequired(awbPrefix, setError, 'awbPrefix')
                                                        }
                                                    }}
                                                    onFocus={(e) => {
                                                        removeError(e, setError)
                                                    }}
                                                error={
                                                error && error["awbNumber"]
                                                    ? t(error["awbNumber"], { ns: "errors" })
                                                    : ""
                                                }
                                                wrapperClassName={"awb-suffix"}
                                                
                                            /> */}
                                        <CommonInput
                                            type="text"
                                            label={t('COMMON.AWB_NUMBER')}
                                            aria-invalid={hasError('awbNumber', error)}
                                            value={awbNumber}
                                            onKeyPress={(evt) => allowNumricOnly(evt)}
                                            onKeyDown={(evt) => formatInputTypeNumber(evt)}
                                            onChange={(e) => handleChangeOfAWB(e.target.value)}
                                            onBlur={(e) => {
                                                let isValid = validateAWB(e.target.value, setError, 'awbNumber');
                                                if (isValid) {
                                                    isValid = validateNumericIfPresent(e.target.value, setError, 'awbNumber');
                                                }
                                                if (e.target.value !== '') {
                                                    validateRequired(awbPrefix, setError, 'awbPrefix');
                                                }
                                            }}
                                            onFocus={(e) => {
                                                removeError(e, setError)
                                            }}
                                            error={error?.awbNumber ? t(error.awbNumber, { ns: "errors" }) : ""}
                                            wrapperClassName="awb-suffix"
                                        />

                                    </div>
                                </div>  


                            </div>
                            {((principal && principal?.type === 'enterprise') || (principal?.type === 'consumer' && placiUser?.stationCode)) &&
                                <div className={`filter-header-left pt-1 mt-3${filterByAwbNumber ? 'disable-time-selection' : ''}`}>
                                    <CommonDropDown
                                        className={"booking-status-dropdown mt-1"}
                                        label="POL type"
                                        value={polType}
                                        options={polTypes}
                                        onChange={(e) => {
                                            handlePolType(e)
                                        }}
                                        isUpdate={true}
                                    />
                                    <div className='awb-checkbox-container'>
                                        <div className='pol-text'>
                                            POL
                                        </div>
                                        {polType && polType === 'AIR' &&
                                            (<MultiSelect value={selectedAirports} onChange={(e) => setSelectedAirports(e.value)} options={airports} optionLabel="airportCode" optionValue='airportCode'
                                                placeholder="Select Airports" className="custom-multiselect" maxSelectedLabels={3} filter resetFilterOnHide={true} />)
                                        }
                                        {polType && polType === 'COU' &&
                                            (<MultiSelect value={selectedCountries} onChange={(e) => handleCountriesFilter(e.value)} options={countries} optionLabel="countryName" optionValue='countryCode'
                                                placeholder="Select Countries" className="" maxSelectedLabels={3} filter resetFilterOnHide={true} />)
                                        }
                                        {polType && polType === 'REG' &&
                                            (<MultiSelect value={selectedRegions} onChange={(e) => handleRegionsFilter(e.value)} options={regions} optionLabel="regionName" optionValue='regionCode'
                                                placeholder="Select Regions" className="custom-multiselect" maxSelectedLabels={3} filter resetFilterOnHide={true} />)
                                        }
                                    </div>
                                </div>
                            }

                        </div>

                        <div className={`all-content ${filterByAwbNumber ? 'disable-time-selection' : ''}`}>

                            <div className=" all-content-left-container" >

                                <div className={(utc !== false) || (timeText !== '') ? 'disable-time-selection departure-date-container' : 'departure-date-container'}>
                                    <div className='departure-date'>Departure Date</div>
                                    <div className={`shipping-shpdate-row`}>
                                        <div className={`form-group calendar-group `}>
                                            <AppCalendar
                                                value={departureFromDate ? new Date(departureFromDate) : null}
                                                onChangeHandler={handleDepartureFromDate}
                                                onFocusHandler={clearError}
                                                minDate={getMinDate()}
                                                maxDate={getMaxDate()}
                                                onErrorHandler={''}
                                                label={t('COMMON.FROM_DATE')}
                                                error={
                                                    departureFromDate === '' && departureToDate !== '' ? "please select date" : ""
                                                }
                                            />
                                        </div>
                                        <div className={`form-group calendar-group `}>
                                            <AppCalendar
                                                value={departureToDate ? new Date(departureToDate) : null}
                                                onChangeHandler={handleDepartureToDate}
                                                onFocusHandler={clearError}
                                                minDate={getMinDate()}
                                                maxDate={getMaxDate()}
                                                onErrorHandler={''}
                                                label={t('COMMON.TO_DATE')}
                                                error={
                                                    departureToDate === '' && departureFromDate !== '' ? "Please select date" : ''
                                                }
                                            />
                                        </div>


                                    </div>

                                </div>
                                <div className={(utc !== false) || (timeText !== '') ? 'disable-time-selection departure-date-container' : 'departure-date-container'}>
                                    <div className='departure-date'>Departure time</div>
                                    <div className={(utc !== false) || (timeText !== '') || (departureFromDate === '') || (departureToDate === '') ? 'disable-time-selection departure-time-slider-container' : 'departure-time-slider-container'}>
                                        <InputText value={departureTimeInHours[0]} className="custom-input-text" />
                                        <Slider
                                            value={departureTime}
                                            onChange={(e) =>
                                                covertDecimalToTime('departure', e.value)
                                            }
                                            range
                                            min={0}
                                            max={1439}

                                            className="custom-slider"

                                        />

                                        <InputText value={departureTimeInHours[1]} className="custom-input-text" />
                                    </div>



                                </div>
                                <div className='time-container'>


                                    <div className="l-checkbox remaining-checkbox">
                                        <input
                                            id='utc'
                                            type='checkbox'
                                            value={utc}
                                            disabled={departedFlights}

                                            onChange={handleRadioUtc}
                                            checked={utc}

                                        />
                                        <label className="mb-0" htmlFor='utc'>
                                            Search by remaining time
                                        </label>
                                    </div>
                                    <CommonDropDown
                                        className={"booking-status-dropdown"}

                                        label={!utc || departedFlights ? "HH:MM" : ""}

                                        options={stdOptions}
                                        value={timeText}
                                        disabled={utc && !departedFlights ? false : true}
                                        onChange={(e) => {
                                            handleText(e)
                                        }}

                                        error={timeError ? timeError : ''}
                                        isNoLabel
                                    />
                                    <div className="l-checkbox remaining-checkbox">
                                        <input
                                            disabled={utc}
                                            id='departed-flights'
                                            type='checkbox'

                                            value={departedFlights}
                                            onChange={(e) => {
                                                setArrivalFromDate('');
                                                setArrivalToDate('');
                                                setArrivalTime([0, 1439]);
                                                setArrivalTimeInHours([
                                                    '0:00 AM',
                                                    '23:59 PM',
                                                ]);
                                                setArrDateError(false)
                                                setDepartedFlights(!departedFlights)
                                                setTimeError(false)
                                                setUtc(false)
                                            }}
                                            checked={departedFlights}

                                        />
                                        <label className="mb-0" htmlFor='departed-flights'>
                                            Departed flights
                                        </label>
                                    </div>

                                </div>
                            </div>


                            <div className="all-content-divider" ></div>
                            <div className=" all-content-left-container" >

                                <div className={utc ? 'disable-time-selection departure-date-container' : 'departure-date-container'}>
                                    <div className='departure-date'>Arrival Date</div>
                                    <div className={`shipping-shpdate-row`}>
                                        <div className={`form-group calendar-group `}>
                                            <AppCalendar
                                                value={arrivalFromDate ? new Date(arrivalFromDate) : null}
                                                onChangeHandler={handleArrivalFromDate}
                                                onFocusHandler={clearError}
                                                minDate={getMinDate()}
                                                maxDate={getMaxDate()}
                                                onErrorHandler={''}
                                                label='From Date'
                                                error={
                                                    arrivalFromDate === '' && arrivalToDate !== '' ? "please select date" : ""
                                                }
                                            />
                                        </div>
                                        <div className={`form-group calendar-group `}>
                                            <AppCalendar
                                                value={arrivalToDate ? new Date(arrivalToDate) : null}
                                                onChangeHandler={handleArrivalToDate}
                                                onFocusHandler={clearError}
                                                minDate={getMinDate()}
                                                maxDate={getMaxDate()}
                                                onErrorHandler={''}
                                                label={t('COMMON.TO_DATE')}
                                                error={
                                                    arrivalFromDate !== '' && arrivalToDate === '' ? "Please select date" : ''
                                                }
                                            />
                                        </div>


                                    </div>

                                </div>

                                <div className={utc ? 'disable-time-selection departure-date-container' : 'departure-date-container'}>
                                    <div className='departure-date'>Arrival time</div>
                                    <div className={(arrivalFromDate === '') || (arrivalToDate === '') || utc ? 'disable-time-selection departure-time-slider-container' : 'departure-time-slider-container'}>
                                        <InputText value={arrivalTimeInHours[0]} className="custom-input-text" />
                                        <Slider
                                            value={arrivalTime}
                                            onChange={(e) =>
                                                covertDecimalToTime('arrival', e.value)
                                            }
                                            range
                                            min={0}
                                            max={1439}
                                            className="custom-slider"

                                        />

                                        <InputText value={arrivalTimeInHours[1]} className="custom-input-text" />
                                    </div>
                                </div>
                                <div className='departure-date-container'>
                                    <div className='departure-date'>Status</div>
                                    <div className='check-container'>


                                        <div className="l-checkbox">
                                            <input
                                                id='nonStop'
                                                type='checkbox'
                                                value={finalized}
                                                name='numberOfStops'
                                                aria-describedby='nonStop'
                                                onChange={handleRadioFinalized}
                                                checked={finalized}

                                            />
                                            <label className="mb-0" htmlFor='nonStop'>
                                                Cleared
                                            </label>
                                        </div>

                                        <div className="l-checkbox">
                                            <input
                                                id='oneStop'
                                                type='checkbox'
                                                value={onHold}
                                                name='numberOfStops'

                                                aria-describedby='oneStop'
                                                onChange={handleRadioOnHold}
                                                checked={onHold}
                                            />
                                            <label htmlFor='oneStop' className='mb-0'>
                                                On hold
                                            </label>
                                        </div>
                                        <div className="l-checkbox">
                                            <input
                                                id='in-progress-check'
                                                type='checkbox'
                                                value={inProgress}
                                                name='in-progress-check'

                                                aria-describedby='in-progress-check'
                                                onChange={handleCheckboxInProgress}
                                                checked={inProgress}
                                            />
                                            <label htmlFor='in-progress-check' className='mb-0'>
                                                In progress
                                            </label>
                                        </div>




                                        {/* </div>
                                 <div className='check-container'> */}
                                        <div className="l-checkbox">
                                            <input
                                                id='cancelled-check'
                                                type='checkbox'
                                                value={isFlightCancelled}
                                                name='cancelled-check'

                                                aria-describedby='cancelled-check'
                                                onChange={handleCheckBoxCancelled}
                                                checked={isFlightCancelled}
                                            />
                                            <label htmlFor='cancelled-check' className='mb-0'>
                                                Cancelled
                                            </label>
                                        </div>
                                        <div className="l-checkbox">
                                            <input
                                                id='no-booking-check'
                                                type='checkbox'
                                                value={isNoBookingChecked}
                                                name='no-booking-check'

                                                aria-describedby='no-booking-check'
                                                onChange={handleCheckBoxNoBookings}
                                                checked={isNoBookingChecked}
                                            />
                                            <label htmlFor='no-booking-check' className='mb-0'>
                                                No bookings
                                            </label>
                                        </div>
                                        {/* <div className="l-checkbox"></div> */}

                                    </div>
                                </div>
                            </div>


                        </div>
                        <div className='filter-footer-container'>
                            <button className="clear-button" type="button" onClick={() => resetFilter()}>Reset all</button>
                            <button
                                type='button'
                                className='filter-button'
                                onClick={(e) => {
                                    onFilter(e)
                                    op.current.hide(e)
                                }
                                }

                                disabled={((timeError) || depDateError || arrDateError || (hasError('awbNumber', error)) || hasError('flightNumber', error)) ? true : false}


                            >
                                {t('COMMON.FILTER')}
                            </button>
                        </div>
                    </div>

                    {/* <div>
                        <div className="popup-header">
                            <button type="button" className='ml-3 primary-button'
                                onClick={() => resetFilter()}>Clear</button>
                        </div>
                    </div> */}
                    {/* <div className='form-container cargo-portal-container'></div> */}


                    {/* <div className='form-container cargo-portal-container'>
                        <div className='form-row flight-filter'>
                            <div className={`col-12 col-md-6 col-lg-3  ${(filterByAwbNumber || utc ) ? 'disable-time-selection' : ''}`}>
                                <label className='form-item__label filter-title' style={{ 'font-weight': 'bold' }}>{t('COMMON.FLT_NO')}</label>

                                <div className='form-row'>
                                    <div className='col-3 col-md-3'>
                                        <input
                                            id='carrierCode'
                                            name='carrierCode'
                                            type='text'
                                            className='form-item__field textFiledCaps'
                                            aria-invalid={hasError('carrierCode', error)}
                                            maxLength='2'
                                            value={carrierCode}
                                            onKeyPress={(envt) => {
                                                return allowAlphaOnly(envt)
                                            }}
                                            onChange={(e) => {
                                                setCarrierCode(e.target.value)
                                            }}
                                            onBlur={(e) => {
                                                validateCarrierCodeRequired(
                                                    flightNo,
                                                    e.target.value,
                                                    setError,
                                                    'carrierCode'
                                                )
                                            }}
                                            onFocus={(e) => {
                                                removeError(e, setError)
                                            }}
                                        />
                                        <span className='form-item__error'>
                                            {error && error['carrierCode']
                                                ? t(error['carrierCode'], { ns: 'errors' })
                                                : ''}
                                        </span>
                                    </div>

                                    <div className='col-9 col-md-9 col-flt-no'>
                                        <input
                                            id='flightNumber'
                                            name='flightNumber'
                                            type='text'
                                            maxLength={5}
                                            placeholder='Flight number'
                                            className='form-item__field'
                                            aria-invalid={hasError('flightNumber', error)}
                                            value={flightNo}
                                            onKeyPress={(e) => {
                                                return restrictSpaceSpecial(e)
                                            }}
                                            onFocus={(e) => {
                                                removeError(e, setError)
                                            }}
                                            onChange={(e) => handleChangeOfFlightNo(e.target.value)}
                                            onBlur={(e) => {
                                                validateFlightNo(e.target.value)
                                            }}
                                        />
                                        <span className='form-item__error'>
                                            {error && error['flightNumber']
                                                ? t(error['flightNumber'], { ns: 'errors' })
                                                : ''}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-3'>
                                <div
                                    className='form-item form-item--checkbox mb-2 ml-2'
                                    data-module='molecules/form-item/FormItem'
                                >
                                    <input
                                        id='filterByAwb'
                                        checked={filterByAwbNumber}
                                        value={filterByAwbNumber}
                                        type='checkbox'
                                        name='filterByAwb'
                                        className='form-item__field'
                                        onChange={(e) => {
                                            setFilterByAwbNumber(!filterByAwbNumber)
                                            resetFilter(true)
                                        }}
                                    />
                                    <label htmlFor='filterByAwb' className={`form-item__label filter-title ${(utc || departedFlights) ? 'disable-time-selection' : ''}`} style={{ 'font-weight': 'bold' }}>
                                        Search by {t('COMMON.AWB_NUMBER')}
                                    </label>
                                </div>
                                <div className={`form-row ${(!filterByAwbNumber || utc || departedFlights) ? 'disable-time-selection' : ''}`}>

                                    <div className='col-3 col-md-4 col-awb-prefix'>
                                        <input
                                            id='awbPrefix'
                                            name='awbPrefix'
                                            type='text'
                                            className='form-item__field'
                                            aria-invalid={hasError('awbPrefix', error)}
                                            value={awbPrefix}
                                            maxLength='3'
                                            onKeyPress={(evt) => {
                                                return allowNumricOnly(evt)
                                            }}
                                            onChange={(e) => {
                                                setAwbPrefix(e.target.value)
                                            }}
                                            onFocus={(e) => {
                                                removeError(e, setError)
                                            }}
                                            onBlur={(e) => {
                                                //validateRequired(e.target.value, setError, 'awbPrefix')
                                            }}
                                        />
                                        <span className='form-item__error'>
                                            {error && error['awbPrefix']
                                                ? t(error['awbPrefix'], { ns: 'errors' })
                                                : ''}
                                        </span>
                                    </div>

                                    <div className='col-9 col-md-8 col-awb-no'>
                                        <input
                                            id='awbNumber'
                                            name='awbNumber'
                                            type='number'
                                            className='form-item__field'
                                            aria-invalid={hasError('awbNumber', error)}
                                            placeholder='AWB'
                                            value={awbNumber}
                                            onKeyPress={(evt) => {
                                                return allowNumricOnly(evt)
                                            }}
                                            onKeyDown={(evt) => formatInputTypeNumber(evt)}
                                            onChange={(e) => handleChangeOfAWB(e.target.value)}
                                            onBlur={(e) => {
                                                let isValid = validateAWB(e.target.value, setError, 'awbNumber')
                                                if (isValid) {
                                                    isValid = validateNumericIfPresent(e.target.value, setError, 'awbNumber')
                                                }
                                                if (e.target.value !== '') {
                                                    validateRequired(awbPrefix, setError, 'awbPrefix')
                                                }
                                            }}
                                            onFocus={(e) => {
                                                removeError(e, setError)
                                            }}
                                        />
                                        <span className='form-item__error'>
                                            {error && error['awbNumber']
                                                ? t(error['awbNumber'], { ns: 'errors' })
                                                : ''}
                                        </span>
                                    </div>
                                </div>

                            </div>
                            {principal && principal?.type === 'enterprise' &&
                                <>
                                    <div className={`col-12 col-lg-2 pl-4 ml-1 ${filterByAwbNumber ? 'disable-time-selection' : ''}`}>
                                        <label className='form-item__label filter-title' style={{ 'font-weight': 'bold' }}>POL type</label>
                                        <Dropdown
                                            value={polType}
                                            options={polTypes}
                                            label=''
                                            onChange={(e) => {
                                                handlePolType(e)
                                            }}
                                            isUpdate={true}
                                        ></Dropdown>
                                    </div>
                                    <div className={`col-12 col-lg-3 ${filterByAwbNumber ? 'disable-time-selection' : ''}`}>
                                        <label className='form-item__label filter-title' style={{ 'font-weight': 'bold' }}>POL</label>
                                        {polType && polType === 'AIR' &&
                                            (<MultiSelect value={selectedAirports} onChange={(e) => setSelectedAirports(e.value)} options={airports} optionLabel="airportCode" optionValue='airportCode'
                                                placeholder="Select Airports" className="w-full md:w-20rem" maxSelectedLabels={3} filter resetFilterOnHide={true} />)
                                        }
                                        {polType && polType === 'COU' &&
                                            (<MultiSelect value={selectedCountries} onChange={(e) => handleCountriesFilter(e.value)} options={countries} optionLabel="countryName" optionValue='countryCode'
                                                placeholder="Select Countries" className="w-full md:w-20rem" maxSelectedLabels={3}  filter resetFilterOnHide={true}  />)
                                        }
                                        {polType && polType === 'REG' &&
                                            (<MultiSelect value={selectedRegions} onChange={(e) => handleRegionsFilter(e.value)} options={regions} optionLabel="regionName" optionValue='regionCode'
                                                placeholder="Select Regions" className="w-full md:w-20rem" maxSelectedLabels={3} filter resetFilterOnHide={true}  />)
                                        }
                                    </div>
                                </>
                            }
                        </div>
                    </div> */}


                    {/* second row */}
                    {/* added */}
                    {/* <div className={`row form-container pt-3 ${filterByAwbNumber ? 'disable-time-selection' : ''}`}>  */}

                    {/* <div className="col-md-6 row form-columns border-BR"> */}

                    {/* <div className={(utc !== false) || (timeText !== '') ? 'disable-time-selection row' : 'row'}>
                                <div className='col-md-12 elements-col'>
                                    <label className="filter-title">Departure Date</label>
                                </div>
                                <div className={`col-md-6 elements-col custom-filterDate ${departureFromDate === '' && departureToDate !== '' ? 'red-border' : ''}`}>
                                    <Calendar
                                        className='form-control'
                                        value={new Date(departureFromDate)}
                                        onChangeHandler={handleDepartureFromDate}
                                        onFocusHandler={clearError}
                                        placeholder='From Date'
                                        minDate={getMinDate()}
                                        maxDate={getMaxDate()}
                                        onErrorHandler={''}
                                    />
                                <label className='validation-error'>{departureFromDate === '' && departureToDate !== '' ? "Please select date" : ''}</label>
                                </div>
                                <div className={`col-md-6 elements-col custom-filterDate ${departureToDate === '' && departureFromDate !== '' ? 'red-border' : ''}`}>
                                    <Calendar
                                        className='form-control'
                                        value={new Date(departureToDate)}
                                        onChangeHandler={handleDepartureToDate}
                                        onFocusHandler={clearError}
                                        placeholder='To Date'
                                        minDate={getMinDate()}
                                        maxDate={getMaxDate()}
                                        onErrorHandler={''}
                                    />
                                    <label className='validation-error'>{departureToDate === '' && departureFromDate !== '' ? "Please select date" : ''}</label>
                                </div>
                                <div className="col-md-12 elements-col mt-3">
                                    <label className="filter-title">Departure time</label>
                                </div>
                                <div className={(utc !== false) || (timeText !== '') || (departureFromDate === '') || (departureToDate === '') ? 'disable-time-selection col-md-12 elements-col' : 'col-md-12 elements-col'}>
                                    <Slider
                                        value={departureTime}
                                        onChange={(e) =>
                                            covertDecimalToTime('departure', e.value)
                                        }
                                        range
                                        min={0}
                                        max={1439}
                                        className='mt-3 mb-4'
                                    />
                                    <div class='row'>
                                        <div class='col-12 col-md'>
                                            <span className='p-inputgroup time-panel'>
                                                <InputText value={departureTimeInHours[0]} />
                                                
                                            </span>
                                        </div>
                                        <div className='seperator'> - </div>
                                        <div class='col-12 col-md'>
                                            <span className='p-inputgroup time-panel'>
                                                <InputText value={departureTimeInHours[1]} />
                                                
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                    {/* <div className='row'>
                                 <div className={`input-dropdown-wrapper col-12 col-md-4 ml-0 stops-radio-wrapper ${departedFlights ? 'disable-time-selection' : ''}`}>
                                    <div class="checkbox-custom pr-0">
                                        <div class="checkbox-item">
                                            <input
                                                id='utc'
                                                type='checkbox'
                                                value={utc}
                                                
                                                className='checkbox-item__field'
                                                
                                                onChange={handleRadioUtc}
                                                checked={utc}

                                            />
                                            <label htmlFor='utc' className='checkbox-item__label filter-title'>
                                                Search by remaining time
                                            </label>
                                        </div>
                                    </div>
                                </div> 
                                <div className='col-12 col-md-4 ml-0 input-dropdown-wrapper mt-3 cargo-portal-container'>
                                   
                                    <Dropdown
                                        value={timeText}
                                        disabled={utc && !departedFlights ? false : true}
                                        options={stdOptions}
                                        label=''
                                        onChange={(e) => {
                                            handleText(e)
                                        }}
                                        isUpdate={true}
                                    ></Dropdown>
                                    <input type='text' value={timeText} onChange={handleText} placeholder='HH:MM'
                                        className={`form-item__field std-input ${!utc || departedFlights ? 'form-item--disabled' : ''}`} disabled={utc && !departedFlights ? false : true} />
                                    <span className='form-item__error mb-1'>{timeError ? timeError : ''}</span>
                                </div> 
                                 <div className={`input-dropdown-wrapper ml-0 col-12 col-md-4 cargo-portal-container stops-radio-wrapper ${utc ? 'disable-time-selection' : ''}`}>
                                    <div class="checkbox-custom pr-0">
                                        <div class="checkbox-item">
                                            <input
                                                id='departed-flights'
                                                type='checkbox'
                                                
                                                value={departedFlights}
                                                
                                                className='checkbox-item__field'
                                                
                                                onChange={(e) => {
                                                    setArrivalFromDate('');
                                                    setArrivalToDate('');
                                                    setArrivalTime([0, 1439]);
                                                    setArrivalTimeInHours([
                                                        '0:00 AM',
                                                        '23:59 PM',
                                                    ]);
                                                    setArrDateError(false)
                                                    setDepartedFlights(!departedFlights)
                                                    setTimeError(false)
                                                    setUtc(false)
                                                }}
                                                checked={departedFlights}

                                            />
                                            <label htmlFor='departed-flights' className='checkbox-item__label'>
                                                Departed flights
                                            </label>
                                        </div>
                                    </div>
                                </div> 
                            </div> */}

                    {/* <div className='col-md filterField_wrap stops-radio-wrapper mt-3'>
                                <label className="filter-title">Status</label>
                                <div class="form-row m-0 mt-2"> */}
                    {/* <div class="checkbox-custom">
                                        <div class="checkbox-item">

                                            <input
                                                id='nonStop'
                                                type='checkbox'
                                                value={finalized}
                                                name='numberOfStops'
                                                className='checkbox-item__field'
                                                aria-describedby='nonStop'
                                                onChange={handleRadioFinalized}
                                                checked={finalized}
                                            />
                                            <label htmlFor='nonStop' className='checkbox-item__label'>
                                                Finalized
                                            </label>
                                        </div>
                                    </div> */}
                    {/* 
                                    <img  className ='down_Arrow_dropdown'src={down_Arrow}>
                                         </img> */}
                    {/* <div class="checkbox-custom">
                                        <div class="checkbox-item">
                                             <input
                                                id='oneStop'
                                                type='checkbox'
                                                //value={onHold}
                                                name='numberOfStops'
                                                className='checkbox-item__field'
                                                aria-describedby='oneStop'
                                                onChange={handleRadioOnHold}
                                                checked={onHold}
                                            />
                                            <label htmlFor='oneStop' className='checkbox-item__label'>
                                                On Hold
                                            </label> 
                                        </div>
                                    </div> */}
                    {/* </div>
                            </div> */}
                    {/* </div> */}

                    {/* rigt section */}
                    {/* <div className="col-md-6 row form-columns">
                            <div className={`col-md-12 elements-col ${utc ? 'disable-time-selection' : ''}`}>
                                <label className="filter-title">Arrival Date</label>
                            </div>
                            <div className={`${utc ? 'disable-time-selection ' : ''}col-md-6 elements-col custom-filterDate ${arrivalFromDate === '' && arrivalToDate !== '' ? 'red-border' : ''}`}>
                                <Calendar
                                    className='form-control'
                                    value={new Date(arrivalFromDate)}
                                    onChangeHandler={handleArrivalFromDate}
                                    onFocusHandler={clearError}
                                    placeholder='From Date'
                                    minDate={getMinDate()}
                                    maxDate={getMaxDate()}
                                    onErrorHandler={''}
                                />
                                <label className='validation-error'>{arrivalFromDate === '' && arrivalToDate !== '' ? "Please select date" : ''}</label>
                            </div>

                            <div className={`${utc ? 'disable-time-selection ' : ''}col-md-6 elements-col custom-filterDate ${arrivalToDate === '' && arrivalFromDate !== '' ? 'red-border' : ''}`}>

                                <Calendar
                                    className='form-control'
                                    value={new Date(arrivalToDate)}
                                    onChangeHandler={handleArrivalToDate}
                                    onFocusHandler={clearError}
                                    placeholder='To Date'
                                    minDate={getMinDate()}
                                    maxDate={getMaxDate()}
                                    onErrorHandler={''}
                                />
                                <label className='validation-error'>{arrivalFromDate !== '' && arrivalToDate == '' ? "Please select date" : ''}</label>
                               
                            </div>
                            <div className={`${utc ? 'disable-time-selection ' : ''} col-md-12 elements-col mt-3`}>
                                <label className="filter-title">Arrival time</label>
                            </div>
                            <div className={`col-md-12 elements-col`}>
                                <div className={(arrivalFromDate === '') || (arrivalToDate === '') || utc ? 'disable-time-selection' : ''}>
                                    <Slider
                                        value={arrivalTime}
                                        onChange={(e) =>
                                            covertDecimalToTime('arrival', e.value)
                                        }
                                        range
                                        min={0}
                                        max={1439}
                                        className='mt-3 mb-4'
                                    />
                                    <div class='row'>
                                        <div class='col-12 col-md'>
                                            <span className='p-inputgroup time-panel'>
                                                <InputText value={arrivalTimeInHours[0]} />
                                               
                                            </span>





                                        </div>
                                        <div className='seperator'> - </div>

                                        <div class='col-12 col-md'>
                                            <span className='p-inputgroup time-panel'>
                                                <InputText value={arrivalTimeInHours[1]} />
                                                
                                            </span>



                                        </div>

                                    </div>
                                </div>
                               

                                <div className='col-md status-field filterField_wrap stops-radio-wrapper mt-12'>
                                    <label className="filter-title">Status</label>
                                    <div class="form-row m-0 mt-6">
                                        <div class="checkbox-custom mt-2">
                                            <div class="checkbox-item">
                                                <input
                                                    id='nonStop'
                                                    type='checkbox'
                                                    value={finalized}
                                                    name='numberOfStops'
                                                    className='checkbox-item__field'
                                                    aria-describedby='nonStop'
                                                    onChange={handleRadioFinalized}
                                                    checked={finalized}
                                                />
                                                <label htmlFor='nonStop' className='checkbox-item__label'>
                                                    Cleared
                                                </label>
                                            </div>
                                        </div>

                                        <div class="checkbox-custom mt-2">
                                            <div class="checkbox-item">
                                                <input
                                                    id='oneStop'
                                                    type='checkbox'
                                                    value={onHold}
                                                    name='numberOfStops'
                                                    className='checkbox-item__field'
                                                    aria-describedby='oneStop'
                                                    onChange={handleRadioOnHold}
                                                    checked={onHold}
                                                />
                                                <label htmlFor='oneStop' className='checkbox-item__label'>
                                                    On hold
                                                </label>
                                            </div>
                                        </div>
                                        <div class="checkbox-custom mt-2">
                                            <div class="checkbox-item">
                                                <input
                                                    id='in-progress-check'
                                                    type='checkbox'
                                                    value={inProgress}
                                                    name='in-progress-check'
                                                    className='checkbox-item__field'
                                                    aria-describedby='in-progress-check'
                                                    onChange={handleCheckboxInProgress}
                                                    checked={inProgress}
                                                />
                                                <label htmlFor='in-progress-check' className='checkbox-item__label'>
                                                    In progress
                                                </label>
                                            </div>
                                        </div>
                                        <div class="checkbox-custom mt-2">
                                            <div class="checkbox-item">
                                                <input
                                                    id='cancelled-check'
                                                    type='checkbox'
                                                    value={isFlightCancelled}
                                                    name='cancelled-check'
                                                    className='checkbox-item__field'
                                                    aria-describedby='cancelled-check'
                                                    onChange={handleCheckBoxCancelled}
                                                    checked={isFlightCancelled}
                                                />
                                                <label htmlFor='cancelled-check' className='checkbox-item__label'>
                                                    Cancelled
                                                </label>
                                            </div>
                                        </div>
                                        <div class="checkbox-custom mt-2">
                                            <div class="checkbox-item">
                                                <input
                                                    id='no-booking-check'
                                                    type='checkbox'
                                                    value={isNoBookingChecked}
                                                    name='no-booking-check'
                                                    className='checkbox-item__field'
                                                    aria-describedby='no-booking-check'
                                                    onChange={handleCheckBoxNoBookings}
                                                    checked={isNoBookingChecked}
                                                />
                                                <label htmlFor='no-booking-check' className='checkbox-item__label'>
                                                    No bookings
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div> */}
                    {/* </div> */}

                    {/* <div>

                        <div className='col-12'>
                            <div className='popup-footer'>
                                <button
                                    type='button'
                                    className='secondary-button'
                                    onClick={(e) => {
                                        op.current.hide(e)
                                        //resetFilter()
                                    }

                                    }
                                >
                                    {t('COMMON.CANCEL')}
                                </button>
                                <button
                                    type='button'
                                    className='ml-3 primary-button'
                                    onClick={(e) => {
                                        onFilter(e)
                                        op.current.hide(e)
                                    }
                                    }
                                    
                                    disabled={((timeError) || depDateError || arrDateError || (hasError('awbNumber', error)) || hasError('flightNumber', error)) ? true : false}


                                >
                                    {t('COMMON.FILTER')}
                                </button>
                            </div>
                        </div>
                    </div> */}
                </OverlayPanel>
            </div>
        </li>
    )
}

export default FilterPopup;